<template>
  <div class="px-page mb-8">
    <div class="flex items-center justify-between">
      <h2 class="font-semibold text-xl leading-tight">
        QA | New Trigger
      </h2>
      <div class="flex items-center justify-end space-x-3">
        <a v-bind:href="$route('qa.triggers.index')" class="btn btn-secondary">Cancel</a>
        <button v-on:click="form.post($route('qa.triggers.store'))" v-bind:disabled="form.processing" class="btn btn-primary" type="button">Save</button>
      </div>
    </div>
  </div>

  <div class="card mb-8">
    <div class="card-body">
      <div class="space-y-6 sm:space-y-5">
        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
          <label for="name" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Sku </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            <input v-model="form.sku" type="text" id="name" class="rounded-md shadow-sm border-gray-300 focus:outline-none focus:border-gray-300 focus:ring-2 focus:ring-offset-2 focus:ring-primary-400 disabled:opacity-25 transition ease-in-out duration-150 max-w-lg block w-full sm:max-w-xs sm:text-sm" />
            <small v-if="errors.sku" class="text-sm text-red-500">{{ errors.sku }}</small>
          </div>
        </div>

        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
          <label for="email" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Title </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            <input v-model="form.title" type="text" id="email" class="rounded-md shadow-sm border-gray-300 focus:outline-none focus:border-gray-300 focus:ring-2 focus:ring-offset-2 focus:ring-primary-400 disabled:opacity-25 transition ease-in-out duration-150 max-w-lg block w-full sm:max-w-xs sm:text-sm" />
            <small v-if="errors.title" class="text-sm text-red-500">{{ errors.title }}</small>
          </div>
        </div>

        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
          <label for="title" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Message </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            <input v-model="form.message" type="text" id="title" class="rounded-md shadow-sm border-gray-300 focus:outline-none focus:border-gray-300 focus:ring-2 focus:ring-offset-2 focus:ring-primary-400 disabled:opacity-25 transition ease-in-out duration-150 max-w-lg block w-full sm:max-w-xs sm:text-sm" />
            <small v-if="errors.message" class="text-sm text-red-500">{{ errors.message }}</small>
          </div>
        </div>

        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
          <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Allow Reject? </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            <Switch v-model="form.reject" v-bind:class="[form.reject ? 'bg-primary-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2']">
              <span class="sr-only">Allow Reject?</span>
              <span aria-hidden="true" v-bind:class="[form.reject ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']" />
            </Switch>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { useForm } from "@inertiajs/vue3";
import {Switch} from "@headlessui/vue";

const { errors } = defineProps({
  errors: Object,
});

const form = useForm({
  sku: null,
  title: null,
  message: null,
  reject: false,
});
</script>
